import AddCommentRounded from '@mui/icons-material/AddCommentRounded';
import CropRotateRounded from '@mui/icons-material/CropRotateRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NotesIcon from '@mui/icons-material/Notes';
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FC, useRef, useState } from 'react';

import { PieceType } from '@apiContract';
import DeleteMenuAction from '@components/Capture/components/DropdownMenuActions/DeleteMenuAction';
import IconWithLoader from '@components/Capture/components/IconWithLoader';
import { tooltips } from '@components/Capture/helper';
import { DrawerTypes, Steps } from '@components/Capture/types';

import { isPieceSend } from '@utils/piece';

import { Props } from './types';

const DropdownMenuActions: FC<Props> = ({ capturePiece, setDrawer, onDeletePiece, onCropClick, currentSession }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const moreButtonRef = useRef<HTMLDivElement>(null);

  const { piece } = capturePiece || {};
  const { pieceType } = currentSession?.params || {};

  const setDrawerIfPieceExists = (drawerType: DrawerTypes) => {
    if (piece) {
      setDrawer(drawerType);
    }
  };

  const handleMoreClick = () => {
    setShowDropdown(true);
  };

  const handleMenuClose = () => {
    setShowDropdown(false);
  };

  return (
    <>
      <Box ref={moreButtonRef} display="inline-flex">
        <IconWithLoader Icon={MoreVertIcon} onClick={handleMoreClick} tooltip="More Actions" />
      </Box>
      <Menu
        open={showDropdown}
        anchorEl={moreButtonRef.current}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { minWidth: 200, maxWidth: '100%', p: 1 } },
        }}
        disablePortal
      >
        {pieceType === PieceType.Mail && (
          <MenuItem onClick={() => onCropClick(Steps.ReviewItems)}>
            <ListItemIcon>
              <CropRotateRounded />
            </ListItemIcon>
            <ListItemText>{tooltips.CropRotateRounded}</ListItemText>
          </MenuItem>
        )}
        <MenuItem onClick={() => setDrawerIfPieceExists(DrawerTypes.Comments)}>
          <ListItemIcon>
            <AddCommentRounded />
          </ListItemIcon>
          <ListItemText>{tooltips.AddCommentRounded}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => setDrawerIfPieceExists(DrawerTypes.AdditionalInfo)}>
          <ListItemIcon>
            <NotesIcon />
          </ListItemIcon>
          <ListItemText>{tooltips.AdditionalInfo}</ListItemText>
        </MenuItem>
        <Divider sx={{ my: 1, borderStyle: 'dashed' }} />
        <DeleteMenuAction disabled={!piece || isPieceSend(piece)} onClick={onDeletePiece} id={piece?.id} />
      </Menu>
    </>
  );
};

export default DropdownMenuActions;
